import axios from "@/libs/api.request";
import config from "@/config";
import { paramFormat } from "@/api/fn";
import { getToken } from "@/libs/util";
const baseUrl =
  process.env.NODE_ENV === "development"
    ? config.baseUrl.dev
    : config.baseUrl.pro;

export default {
  sysQueryUserListString(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/user/sysQueryUserListString",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  sysQueryUserById(data) {
    let token = getToken();
    let param = {"id": data.id};
    let url = baseUrl + "/sys/user/sysQueryUserById/" + param.id;
    return axios.request({
      url: url,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "GET"
    });
  },
  sysQueryUserList(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/user/sysQueryUserList",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  queryByKeyword(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/user/queryByKeyword",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  // sendCheckCode(data) {
  //   // let token = getToken();
  //   let param = paramFormat(data);
  //   return axios.request({
  //     url: baseUrl + "/sms/sendCheckCode",
  //     data: param,
  //     dataType: "json",
  //     headers: {
  //       // token: token,
  //       "Content-Type": "application/json; charset=utf-8"
  //     },
  //     method: "POST"
  //   });
  // },
  // sysQueryUserList(data) {
  //   let token = getToken();
  //   let param = paramFormat(data);
  //   return axios.request({
  //     url: baseUrl + "/sys/user/sysQueryUserList",
  //     data: param,
  //     dataType: "json",
  //     headers: {
  //       token: token,
  //       "Content-Type": "application/json; charset=utf-8"
  //     },
  //     method: "POST"
  //   });
  // },
  sysNewUser(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/user/sysNewUser",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  resetPassword(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/user/resetPassword",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  sysUpdateUserById(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/user/sysUpdateUserById",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  sysDeleteUserById(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/sys/user/sysDeleteUserById",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  },
  sysQueryDistrictList(data) {
    let token = getToken();
    let param = paramFormat(data);
    return axios.request({
      url: baseUrl + "/district/sysQueryDistrictList",
      data: param,
      dataType: "json",
      headers: {
        token: token,
        "Content-Type": "application/json; charset=utf-8"
      },
      method: "POST"
    });
  }
};
